import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

const API = "https://backend.smpn1kamal.sch.id/api";

export default function FormDataGuru({ isOpen, onClose, editData }) {
  const { token } = useAuth(); // ← pakai session token

  const [form, setForm] = useState({
    nama_lengkap: "",
    nip: "",
  });

  const [mapelList, setMapelList] = useState([]);
  const [selectedMapel, setSelectedMapel] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingMapel, setLoadingMapel] = useState(false);

  /* ================= FETCH DAFTAR MAPEL ================= */
  useEffect(() => {
    const fetchMapel = async () => {
      try {
        setLoadingMapel(true);
        const res = await axios.get(`${API}/datamapel`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMapelList(res.data);
      } catch {
        toast.error("Gagal mengambil mapel");
      } finally {
        setLoadingMapel(false);
      }
    };

    if (isOpen) fetchMapel();
  }, [isOpen, token]);

  /* ================= ISI DATA SAAT EDIT ================= */
  useEffect(() => {
    if (editData) {
      setForm({
        nama_lengkap: editData.nama_lengkap || "",
        nip: editData.nip || "",
      });

      if (editData.mapel) {
        setSelectedMapel(editData.mapel.map((m) => m.id_mapel));
      } else {
        setSelectedMapel([]);
      }
    } else {
      setForm({ nama_lengkap: "", nip: "" });
      setSelectedMapel([]);
    }
  }, [editData, isOpen]);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= TOGGLE CHECKBOX MAPEL ================= */
  const handleToggleMapel = (id_mapel, checked) => {
    if (checked) {
      setSelectedMapel((prev) => [...prev, id_mapel]);
    } else {
      setSelectedMapel((prev) => prev.filter((id) => id !== id_mapel));
    }
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedMapel.length === 0) {
      toast.error("Pilih minimal satu mata pelajaran");
      return;
    }

    try {
      setLoading(true);

      await axios.put(
        `${API}/data-guru/${editData.id_guru}`,
        {
          ...form,
          mapel: selectedMapel,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Data guru berhasil diperbarui");
      onClose();
    } catch {
      toast.error("Gagal update data");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  /* ================= MODAL ================= */
  return createPortal(
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-[99999] px-4">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 max-h-[90vh] overflow-y-auto">

        <h2 className="text-lg font-semibold text-indigo-600 mb-4">
          Edit Data Guru
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          {/* NAMA */}
          <div>
            <label className="text-xs text-slate-500">Nama Lengkap</label>
            <input
              type="text"
              name="nama_lengkap"
              value={form.nama_lengkap}
              onChange={handleChange}
              required
              className="w-full mt-1 px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-indigo-400 outline-none"
            />
          </div>

          {/* NIP */}
          <div>
            <label className="text-xs text-slate-500">NIP</label>
            <input
              type="text"
              name="nip"
              value={form.nip}
              onChange={handleChange}
              className="w-full mt-1 px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-indigo-400 outline-none"
            />
          </div>

          {/* MATA PELAJARAN */}
          <div>
            <label className="text-xs font-semibold text-slate-600 mb-2 block">
              Mata Pelajaran
            </label>

            {loadingMapel ? (
              <p className="text-xs text-gray-400">Memuat mata pelajaran...</p>
            ) : (
              <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto">
                {mapelList.map((m) => (
                  <label
                    key={m.id_mapel}
                    className="flex items-center gap-2 text-sm border p-2 rounded-lg cursor-pointer hover:bg-slate-50 transition"
                  >
                    <input
                      type="checkbox"
                      checked={selectedMapel.includes(m.id_mapel)}
                      onChange={(e) => handleToggleMapel(m.id_mapel, e.target.checked)}
                    />
                    {m.nama_mapel}
                  </label>
                ))}

                {mapelList.length === 0 && (
                  <p className="col-span-2 text-center text-xs text-gray-400 py-3">
                    Tidak ada data mata pelajaran
                  </p>
                )}
              </div>
            )}
          </div>

          {/* BUTTON */}
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-full text-sm hover:bg-slate-50 transition"
            >
              Batal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full text-sm disabled:opacity-60 transition"
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>

        </form>
      </div>
    </div>,
    document.body
  );
}